import React from 'react';
import { useSelector } from 'react-redux';
import defaultIcon from '../../../../assets/image/company_default_icon.png';

export default function DevelopmentInProgress() {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	return (
		<div
			className="justify-content-center align-items-center"
			style={{ display: 'flex', flexDirection: 'column', marginTop: '15%' }}
		>
			<div className="error-code">
				<img
					src={user?.organisation_logo ? user?.organisation_logo : defaultIcon}
					width={80}
					height={80}
					className="rounded-4"
					alt="logo"
				/>
			</div>
			<div className="error-message my-2">{user?.organisation_name || ''}</div>
			<div className="error-message my-1">Development In Progress</div>
		</div>
	);
}
